import { render, staticRenderFns } from "./WorkTitleCard.vue?vue&type=template&id=35f5ffc4"
import script from "./WorkTitleCard.vue?vue&type=script&lang=js"
export * from "./WorkTitleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports